import React, {useEffect, useState} from 'react'
import {Button} from "primereact/button";
import FetchUtil from "../../../../util/FetchUtil";
import ConfigUtil from "../../../../util/ConfigUtil";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";
import GasteingabeNuSpielerauswahl from "./GasteingabeNuSpielerauswahl";

/**
 * Spieler der Gastmannschaft anlegen, ändern und löschen. Bei nu-Spielbegegnungen (externMeetingId) werden
 * die Spieler aus nu ausgewählt. Logik wie PublicLigaspielttagMannschaftTab der alten Ansicht.
 */
export default function GasteingabeMannschaft({tournamentid, qrcode}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [players, setPlayers] = useState([]);
    const [heimVerwaltetGastdaten, setHeimVerwaltetGastdaten] = useState(undefined);
    const [externMeetingId, setExternMeetingId] = useState(undefined);
    // Spieler, dessen Löschen gerade bestätigt werden soll
    const [loeschenPlayer, setLoeschenPlayer] = useState(undefined);
    const [playerId, setPlayerId] = useState(undefined);
    const [playerName, setPlayerName] = useState("");
    const [showBDVNuGuestPlayers, setShowBDVNuGuestPlayers] = useState(false);

    useEffect(() => {
        ladeDaten();
    }, []);

    const ladeDaten = () => {
        setErrorMessage(undefined);
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.public + "/ligaspieltag/gastspieler/" + tournamentid + "/" + qrcode,
            (json) => {
                setPlayers(json.players);
                setHeimVerwaltetGastdaten(json.heimVerwaltetGastdaten);
                setExternMeetingId(json.externMeetingId);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            });
    }

    const savePlayer = () => {
        setErrorMessage(undefined);
        if (playerName.trim().length === 0) {
            setErrorMessage("Spielername muss gesetzt sein.");
            return;
        }
        const data = {playerId: playerId, name: playerName.trim()};
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.public + "/ligaspieltag/saveplayer/" + tournamentid + "/" + qrcode,
            data,
            (json) => {
                setInfoMessage("Spieler wurde gespeichert.");
                setPlayers(json.players);
                resetPlayer();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            });
    }

    const deletePlayer = () => {
        setErrorMessage(undefined);
        const data = {playerId: loeschenPlayer.id};
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.public + "/ligaspieltag/deleteplayer/" + tournamentid + "/" + qrcode,
            data,
            (json) => {
                setPlayers(json.players);
                setLoeschenPlayer(undefined);
                if (playerId === data.playerId) {
                    resetPlayer();
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setLoeschenPlayer(undefined);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
                setLoeschenPlayer(undefined);
            });
    }

    const resetPlayer = () => {
        setPlayerName("");
        setPlayerId(undefined);
    }

    const getEingabe = () => {
        const bearbeiten = playerId !== undefined;
        return <form className="dhpt-karte dhpt-gast-eingabe" onSubmit={(e) => {
            e.preventDefault();
            savePlayer();
        }}>
            <label htmlFor="dhpt-gast-spielername" className="dhpt-karte-titel">
                <span>{bearbeiten ? "Spieler ändern" : "Neuen Spieler anlegen"}</span>
            </label>
            <div className="dhpt-gast-eingabe-zeile">
                <input id="dhpt-gast-spielername" type="text" className="dhpt-suche-feld dhpt-gast-feld" placeholder="Name des Spielers"
                       autoComplete="off" value={playerName} onChange={(e) => setPlayerName(e.target.value)}/>
                <Button type="submit" icon="pi pi-check" label="Speichern" disabled={playerName.trim().length === 0}/>
                {bearbeiten &&
                    <Button type="button" icon="pi pi-times" label="Abbrechen" className="p-button-outlined dhpt-button-hell" onClick={() => resetPlayer()}/>
                }
            </div>
        </form>
    }

    const getSpielerListe = () => {
        // Spieler mit idShortSinglePlayer1 sind Doppel-Einträge und werden nicht einzeln gepflegt
        const angezeigt = players.filter(player => player.idShortSinglePlayer1 === null || player.idShortSinglePlayer1 === undefined);
        if (angezeigt.length === 0) {
            return <p className="dhpt-hinweis">Es sind noch keine Spieler vorhanden.</p>
        }
        return <ul className="dhpt-gast-mannschaft">
            {angezeigt.map(player => <li key={player.id} className={player.id === playerId ? "dhpt-gast-mitglied dhpt-gast-mitglied-aktiv" : "dhpt-gast-mitglied"}>
                <i className="pi pi-user" aria-hidden="true"/>
                <span className="dhpt-gast-name">{player.name}</span>
                <span className="dhpt-gast-aktionen">
                    {!externMeetingId &&
                        <button type="button" className="dhpt-gast-knopf" aria-label={player.name + " ändern"} title="Ändern"
                                onClick={() => {
                                    setPlayerName(player.name);
                                    setPlayerId(player.id);
                                }}>
                            <i className="pi pi-pencil" aria-hidden="true"/>
                        </button>
                    }
                    <button type="button" className="dhpt-gast-knopf" aria-label={player.name + " löschen"} title="Löschen"
                            onClick={() => setLoeschenPlayer(player)}>
                        <i className="pi pi-trash" aria-hidden="true"/>
                    </button>
                </span>
            </li>)}
        </ul>
    }

    const getLoeschenBestaetigung = () => {
        return <div className="dhpt-gast-ebene" role="alertdialog" aria-modal="true" aria-label="Spieler löschen">
            <div className="dhpt-gast-ebene-fenster">
                <div className="dhpt-gast-ebene-kopf">
                    <div className="dhpt-fett">Spieler löschen</div>
                </div>
                <p>Möchtest du <b>{loeschenPlayer.name}</b> wirklich löschen?</p>
                <p className="dhpt-hinweis">Gelöscht werden kann ein Spieler nur, solange er noch keinem Spiel zugewiesen ist.</p>
                <div className="dhpt-gast-ebene-knoepfe">
                    <Button icon="pi pi-trash" label="Löschen" className="p-button-danger" onClick={() => deletePlayer()}/>
                    <Button icon="pi pi-times" label="Abbrechen" className="p-button-outlined dhpt-button-hell" onClick={() => setLoeschenPlayer(undefined)}/>
                </div>
            </div>
        </div>
    }

    return <div>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage}
                            onClearInfoMessage={() => setInfoMessage(undefined)}
                            onClearErrorMessage={() => setErrorMessage(undefined)}/>
        {heimVerwaltetGastdaten === undefined
            ? <p className="dhpt-hinweis">Mannschaft wird geladen …</p>
            : <div className="dhpt-gast-abschnitte">
                {externMeetingId
                    ? <div>
                        <Button icon="pi pi-users" label="Spieler auswählen" onClick={() => setShowBDVNuGuestPlayers(true)}/>
                    </div>
                    : getEingabe()
                }
                <section>
                    <h3 className="dhpt-karte-titel"><span>Spieler der Gastmannschaft</span></h3>
                    {getSpielerListe()}
                </section>
            </div>
        }
        {loeschenPlayer !== undefined && getLoeschenBestaetigung()}
        {showBDVNuGuestPlayers && <GasteingabeNuSpielerauswahl externMeetingId={externMeetingId}
                                                            tournamentId={tournamentid}
                                                            qrCode={qrcode}
                                                            tournamentPlayers={players}
                                                            onClose={() => setShowBDVNuGuestPlayers(false)}
                                                            onRefresh={() => ladeDaten()}/>}
    </div>
}
